import React from 'react';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { PositionsDTO, TaxLotDetailsDTO } from '../GainLossMobile.meta';
import { TableRowMobile } from './TableRowMobile/TableRowMobile';
import {
  formatCurrency,
  formatNumber,
  formatPercentage,
} from '../../../../../../CommonUtils/formatNumber';

interface Props {
  type: string;
  position: PositionsDTO | null;
  goBack(): void;
  setTaxSlots(data: TaxLotDetailsDTO[] | null): void;
}

export const PositionMobile = ({ type, position, goBack, setTaxSlots }: Props) => {
  if (!position) {
    return null;
  }

  return (
    <>
      <Button
        variant="primary"
        size="large"
        leftIcon="fas fa-arrow-left"
        isTruncated
        onClick={goBack}
        width="100%"
        style={{ color: 'white' }}
        my="8"
      >
        {position.name}
      </Button>
      <HtmlTable variant="embedded">
        <table style={{ tableLayout: 'fixed' }}>
          <colgroup>
            <col width="50%" />
            <col width="50%" />
          </colgroup>
          <thead>
            <tr>
              <th>
                <Text variant="tableHeader" textAlign="left">
                  Name
                </Text>
              </th>
              <th>
                <Text variant="tableHeader" textAlign="right">
                  Value
                </Text>
              </th>
            </tr>
          </thead>
          <tbody>
            <TableRowMobile label="Ticker" value={position.ticker} />
            <TableRowMobile
              label="Units"
              value={formatNumber(position.units ?? 0, { mantissa: 2 })}
            />
            <TableRowMobile
              label="Price"
              value={formatCurrency(position.price ?? 0, { decimalPlaces: 2 })}
            />
            {type === 'unrealized' && (
              <>
                <TableRowMobile
                  label="Market Value"
                  value={formatCurrency(position.marketValue ?? 0, { decimalPlaces: 2 })}
                />
                <TableRowMobile
                  label="Allocation"
                  value={formatPercentage(position.percent ?? 0 / 100, { mantissa: 2 })}
                />
              </>
            )}
            <TableRowMobile
              label="Cost Basis"
              value={formatCurrency(position.costBasis ?? 0, { decimalPlaces: 2 })}
            />
            <TableRowMobile
              label="Short Term Gain Loss"
              value={formatCurrency(position.shortTerm ?? 0, { decimalPlaces: 2 })}
            />
            <TableRowMobile
              label="Long Term Gain Loss"
              value={formatCurrency(position.longTerm ?? 0, { decimalPlaces: 2 })}
            />
            <TableRowMobile
              label="Gain Loss"
              value={formatCurrency(position.gainLoss ?? 0, { decimalPlaces: 2 })}
            />
            {type === 'realized' && (
              <TableRowMobile
                label="Proceeds"
                value={formatCurrency(position.proceeds ?? 0, { decimalPlaces: 2 })}
              />
            )}
          </tbody>
        </table>
      </HtmlTable>
      {!!position?.taxLotDetails.length && (
        <Box display="flex" justifyContent="center">
          <Button variant="primary" onClick={() => setTaxSlots(position.taxLotDetails)} mt="8">
            Show {position.taxLotDetails.length} Tax Lot{position.taxLotDetails.length > 1 && 's'}
          </Button>
        </Box>
      )}
    </>
  );
};
